"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_USD_EXTENSIONS = void 0;
exports.isUsdFileType = isUsdFileType;
const file_utils_1 = require("./file-utils");
// HOOPS cannot read USD, so these route through the USD converter before asset
// generation sees them. Kept in sync with the converter's own extension set.
exports.VALID_USD_EXTENSIONS = ['.usd', '.usdz'];
function isUsdFileType(filename) {
    return exports.VALID_USD_EXTENSIONS.includes((0, file_utils_1.getFileExtension)(filename.toLowerCase()));
}
//# sourceMappingURL=is-usd-file-type.js.map